'use es6';

import { OrderedSet, List, fromJS } from 'immutable';
import { SEARCH } from '../../../constants/configTypes';
import { COUNT } from '../../../constants/metricTypes';
import { CRM_OBJECT, SEQUENCE_ENROLLMENTS, SEQUENCE_STEP_ENROLLMENTS } from '../../../constants/dataTypes';
import { DESC } from '../../../constants/sortOrder';
import { Config } from '../..';
import { Metric } from '../../metrics';
import { defaultProperties } from '../defaultProperties';
import { makeFilters } from '../filters';
import { buildDrilldownReport } from '../report';
import { ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS, HUBSPOT_CRM_OBJECTS_BY_ID } from '../../../crmObjects/utils';
const SEQUENCE_ENROLLMENTS_OBJECT_TYPE_ID = ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS.get(SEQUENCE_ENROLLMENTS);
const SEQUENCE_STEP_ENROLLMENTS_OBJECT_TYPE_ID = ALLOWLISTED_HUBSPOT_DEFINED_CRM_OBJECTS.get(SEQUENCE_STEP_ENROLLMENTS);
const getSequenceEnrollmentsDrilldown = (report, keys, options) => {
  const dataType = report.getIn(['config', 'dataType']);
  const objectTypeId = report.getIn(['config', 'objectTypeId']);
  const config = report.get('config');
  const dimensions = config.get('dimensions') || List();
  const properties = OrderedSet([...defaultProperties[HUBSPOT_CRM_OBJECTS_BY_ID.get(objectTypeId)], ...dimensions]).toList();
  return makeFilters(report.get('config'), keys, options).then(filters => {
    return Config({
      configType: SEARCH,
      limit: 5,
      dataType,
      objectTypeId: report.getIn(['config', 'objectTypeId']),
      metrics: properties.map(property => Metric({
        property,
        metricTypes: [COUNT]
      })),
      filters,
      sort: fromJS([{
        property: 'hs_enrolled_at',
        order: DESC
      }])
    });
  }).then(drilledConfig => buildDrilldownReport(report, drilledConfig, options));
};
export default {
  isSupported: report => report.getIn(['config', 'dataType']) === CRM_OBJECT && (report.getIn(['config', 'objectTypeId']) === SEQUENCE_ENROLLMENTS_OBJECT_TYPE_ID || report.getIn(['config', 'objectTypeId']) === SEQUENCE_STEP_ENROLLMENTS_OBJECT_TYPE_ID),
  generate: getSequenceEnrollmentsDrilldown
};